<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/')"></span>
    </div>
    <div class="title">请选择仓储规模</div>

      <div class="car-choose">
        <div class="car" :class="{ active: isActive('1')}" @click="orderUpdate('storage_scale','1');changeSlide(1)">中尺寸</div>
        <div class="car" :class="{ active: isActive('2')}" @click="orderUpdate('storage_scale','2');changeSlide(2)">大尺寸</div>
        <div class="car" :class="{ active: isActive('3')}" @click="orderUpdate('storage_scale','3');changeSlide(3)">特大尺寸</div>
      </div>
      <div>
        <swiper :options="swiperOption" ref="swiper">
          <swiper-slide><div class="carshow"><router-link :to="vehicle_id"><img src='../../assets/img/warehouse/a.png'></router-link></div></swiper-slide>
          <swiper-slide><div class="carshow"><router-link :to="vehicle_id"><img src='../../assets/img/warehouse/b.png'></router-link></div></swiper-slide>
          <swiper-slide><div class="carshow"><router-link :to="vehicle_id"><img src='../../assets/img/warehouse/c.png'></router-link></div></swiper-slide>

          <div class="swiper-button-prev" slot="button-prev"><span class="icon-chevron-left"></span></div>
          <div class="swiper-button-next" slot="button-next"><span class="icon-chevron-right"></span></div>
        </swiper>
      </div>

      <div class="car-detail" v-show="order.data.storage_scale === '1'">
        <div><span class="icon-point"></span> 容积：长宽高 2 x 2 x 2.5 m </div>
        <div><span class="icon-point"></span> 适合一床 + 简单小家具</div>
        <div class="more-detail">
          <span class="check-detail"></spab><span class="icon-chevron-down"></span> <router-link :to="vehicle_id">查看中尺寸详情与资费</router-link></span>
        </div>
      </div>

      <div class="car-detail" v-show="order.data.storage_scale === '2'">
        <div><span class="icon-point"></span> 容积：长宽高 3 x 2 x 2.5 m </div>
        <div><span class="icon-point"></span> 适合一床 + 家具家电</div>
        <div class="more-detail">
          <span class="check-detail"></spab><span class="icon-chevron-down"></span> <router-link :to="vehicle_id">查看大尺寸详情与资费</router-link></span>
        </div>
      </div>

      <div class="car-detail" v-show="order.data.storage_scale === '3'">
        <div><span class="icon-point"></span> 容积：长宽高 3 x 3 x 2.5 m </div>
        <div><span class="icon-point"></span> 适合两床 + 沙发 + 家电</div>
        <div class="more-detail">
          <span class="check-detail"></spab><span class="icon-chevron-down"></span> <router-link :to="vehicle_id">查看特大尺寸详情与资费</router-link></span>
        </div>
      </div>


      <div class="btn-box-fix">
        <div class="car-info" v-show="order.data.storage_scale === '1'">
          <div><span class="icon-coin-dollar color-orange"></span> <span><span class="color-orange">存储费 $50 / 周</span>（不含上门搬运费用）</span></div>
        </div>
        <div class="car-info" v-show="order.data.storage_scale === '2'">
          <div><span class="icon-coin-dollar color-orange"></span> <span><span class="color-orange">存储费 $60 / 周</span>（不含上门搬运费用）</span></div>
        </div>
        <div class="car-info" v-show="order.data.storage_scale === '3'">
          <div><span class="icon-coin-dollar color-orange"></span> <span><span class="color-orange">存储费 $70 / 周</span>（不含上门搬运费用）</span></div>
        </div>
        <div class="btn-container">
          <div class="btn active" @click="orderUpdateAll('/warehouse-step2')" >下一步</div>
        </div>
      </div>
      <img :src="pixelURL('move','chexing')" class="hide">
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'step2',
  data () {
    return {
      order:{
        service:'warehouse',
        data:{
          username:"",
          userphone:"",
          pick_date:"",
          return_date:"",
          pick_period:"",
          return_period:"",
          storage_scale:"1",
          ifSelfPick:"",
          ifSelfReturn:"",
          pick_street: "",
          pick_suburb: "",
          pick_state: "NSW",
          pick_postcode: "",
          pick_floor:"",
          pick_parking:"",
          return_street: "",
          return_suburb: "",
          return_state: "NSW",
          return_postcode: "",
          return_floor:"",
          return_parking:"",
          agency: "",
          return_addr_pending:"",
          return_time_pending:"",
          msg:"",
          coupon:"",
          couponLocked:"",
          couponValue:0,
          estimated_week:14,
          cal_week:0,
          warehouse:""
        },
      },
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper: function () {
      return this.$refs.swiper.swiper;
    },
    vehicle_id : function () {
      return "#"+this.order.data.storage_scale;
    }, 

  },
  mounted: function () {
    let suggest="";

    //如果本来就存过了storage_scale，就直接使用正在存的值
    if(this.order.data.storage_scale){
      suggest = this.order.data.storage_scale;
    }

    //如果是从最终订单确认页，进来编辑的，则直接使用正在存的值
    if(this.order.data.storage_scale&&localStorage.isEditing){
      suggest = this.order.data.storage_scale;
    }
    this.orderUpdate('storage_scale',suggest);
    this.changeSlide(suggest);

    let that = this;
    that.swiper.on('slideChange', function () {
      let swiperIndex = that.swiper.activeIndex + 1;
      that.orderUpdate('storage_scale',swiperIndex.toString());
    });
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "warehouse"){
        this.order = localParsed;
      }
      else{
        // this.$router.push('/');
      }
    }
    else{
      // this.$router.push('/');
    }
  },
  methods: {
    changeSlide(key){
      key = key - 1;
      this.swiper.slideTo(key, 200, false)
    },
    isActive(val) {
      if(this.order.data.storage_scale==val){
        return true;
      }
      else{
        return false;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.btn-paddy{
}

.container /deep/ .swiper-button-prev, .container /deep/ .swiper-button-next{
  font-size:2.4em;
  color:#bbb;
  margin-right: 18px;
}

.container /deep/ .swiper-button-prev, .container /deep/ .swiper-container-rtl .swiper-button-next{
  background:none;
}

.container /deep/ .swiper-button-next, .container /deep/ .swiper-container-rtl .swiper-button-prev{
  background:none;
}
.carshow{
  text-align:center;
  img{
    width:84%;
  }
}
.car-detail{
  margin-top:20px;
  font-size:0.9em;
  color:#666;
  text-align:center;
  .icon-point{
    color:#fe9567;
  }
}
.car-choose{
  border-bottom:1px solid #eee;
  width:86%;
  margin:1em auto 1.8em auto;
  display: flex;
  justify-content:space-around;
  .car{
    padding:0 0.2em 0 0.2em;
    font-size:0.9em;
  }
  .car.active{
    color:#fe9567;
    border-bottom: solid 3px #fe9567;
    padding-bottom:0.6em;
  }
}

.fade-leave-active {
  transition-duration: 0s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.check-detail{
  border: 2px solid #e3e3e3;
  padding: 8px 18px 8px 14px;
  margin-top: 14px;
  display: inline-block;
  border-radius: 50px;
    -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-name: breathe;
    -webkit-animation-duration: 1000ms;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-direction: alternate;
}

.car-info{
  padding: 10px 30px 0 30px;
  text-align:left;
  color:#999;
  font-size:0.9em;
  display: flex;
  justify-content:space-around;
}

@-webkit-keyframes breathe {
    0% {
      border: 2px solid #eeeeee;
    }

    100% {
      border: 2px solid #fad0be;
    }
}


</style>



// WEBPACK FOOTER //
// src/pages/warehouse/step1.vue